export const REVIEW_YEARS_MAX_COUNT = 5;
export const VALID_YEAR_MONTH_LIMIT = 2;
export const MAX_REVIEW_INPUT_CHARS = 2500;

export const RATES = [
  { id: 200000, name: 'Sobre nivel' },
  { id: 100000, name: 'Nivel' },
  { id: 0, name: 'Bajo nivel' },
  { id: -1, name: 'Ni idea' },
];
